import React from 'react';
import Button from '../Button';
import styles from './styles.module.scss';

const FormButtons = ({
  isEditing,
  isLoading,
  onClose,
  onDelete,
  onSubmit,
  setSendMail,
  t
}) => {
  return (
    <div className={styles.buttonContainer}>
      <div className={styles.leftButtonGroup}>
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isLoading}
        >
          {t("modal.newbooking.cancelButton")}
        </Button>
        
        {/* {isEditing && (
          <Button
            variant="danger"
            onClick={onDelete}
            disabled={isLoading}
          >
            {t("modal.newbooking.deleteButton")}
          </Button>
        )} */}
      </div>

      <div className={styles.rightButtonGroup}>
        {!isEditing ? (
          <>
            <Button
              variant="primary"
              onClick={() => {
                setSendMail(false);
                onSubmit({ preventDefault: () => {} });
              }}
              disabled={isLoading}
              loading={isLoading}
            >
              {t("modal.newbooking.confirmButton")}
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setSendMail(true);
                onSubmit({ preventDefault: () => {} });
              }}
              disabled={isLoading}
              loading={isLoading}
            >
              {t("modal.newbooking.confirmAndEmailButton")}
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="primary"
              onClick={() => {
                setSendMail(false);
                onSubmit({ preventDefault: () => {} });
              }}
              disabled={isLoading}
              loading={isLoading}
            >
              {t("modal.newbooking.editButton")}
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setSendMail(true);
                onSubmit({ preventDefault: () => {} });
              }}
              disabled={isLoading}
              loading={isLoading}
            >
              {t("modal.newbooking.editAndEmailButton")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default FormButtons;